import React, { useContext } from "react";
import { StoreContext } from "../context/Store";
import AddSelectBlock from "../parts/AddSelectBlock";
import Button from "../parts/Button";
import SearchSelectBlock from "../parts/SearchSelectBlock";
import Text from "../parts/Text";

export interface CourcesProps {}

export interface CourcesState {}

export const Cources = React.forwardRef<HTMLDivElement, CourcesProps>(
  (props, ref) => {
    const store = useContext(StoreContext);
    const { courses, addCourse, setTempCourse, tempCourse, toggleCourse } =
      store;
    return (
      <section id="cources" className="mb-5" ref={ref}>
        <Text tag="h2" color="pink" classes="mb-5">
          Kursy
        </Text>
        <Text tag="h4" classes="mb-2" color="blue">
          Wpisz ukończone kursy
        </Text>
        <Text tag="p">
          A jeśli nie masz zbyt dużego doświadczenia, warto ukończyć dodatkowe
          kursy i pochwalić się nimi w swoim CV.{" "}
        </Text>
        <SearchSelectBlock search data={courses} toggleAction={toggleCourse}>
          <AddSelectBlock
            value={tempCourse}
            add={addCourse}
            onChange={setTempCourse}
            placeholder="Kurs (wpisz jaki)"
          />
        </SearchSelectBlock>
        <div className="d-flex justify-content-end mb-5">
          <Button
            onClick={addCourse}
            classes="smaller-text pink-border"
            disabled={tempCourse.length < 3}
          >
            dodaj
          </Button>
        </div>
      </section>
    );
  }
);

export default Cources;
